import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SysAdminService } from "../../services/sysadmin.service";
import { ContainersToChangeModel } from "./ContainersToChangeModel";
import { UserGroupAddContainerComponent } from "./user-group-add-container/user-group-add-container.component";

@Component({
	selector: "caass-user-group-assign-container",
	templateUrl: "./user-group-assign-container.component.html",
	styleUrls: ["./user-group-assign-container.component.css"],
})
export class UserGroupAssignContainerComponent implements OnInit {
	constructor(private sysAdminService: SysAdminService, private dialogService: DialogService) {}

	ngOnInit(): void {}

	ngOnChanges() {
		this.errorMessage = "";

		if (this.SelectedUserGroup != undefined && this.SelectedUserGroup != null) {
			this.loadContainerList();
		} else {
			this.lstContainers = [];
		}
	}

	/////////////////////////////////////////
	// Data
	/////////////////////////////////////////

	@Input() AllowMultipleSchools: boolean = false;
	@Input() SchoolID: any;
	@Input() SelectedUserGroup: any;
	@Output() AddedContainer: EventEmitter<any> = new EventEmitter();

	lstContainers: any = [];
	SelectedContainers: any = [];

	cols = [{ field: "SchoolGroupDesc", header: "School Container" }];

	pagerows: any = 5;
	pagefirst: any = 0;

	errorMessage: any = "";

	loading: any = false;

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////

	private loadContainerList() {
		this.loading = true;

		var result = this.sysAdminService.UserGroupGetContainers(this.SelectedUserGroup.UserGroupID);
		result.subscribe(
			(response) => {
				this.lstContainers = response;
				this.SelectedContainers = [];

				this.loading = false;
			},
			(error) => {}
		);
	}
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		if (this.SelectedUserGroup == undefined || this.SelectedUserGroup == null) {
			this.errorMessage = "Select a User Group to add school containers to";
			return;
		}

		if (this.SelectedUserGroup.UserLevelID == 3 && this.AllowMultipleSchools == false) {
			this.errorMessage = "School Level Groups can only be assigned to one school";
			return;
		}

		var ref = this.dialogService.open(UserGroupAddContainerComponent, {
			header: "Add School Containers",
			width: "fit-content",
			data: {
				SchoolID: this.SchoolID,
				SelectedContainers: this.lstContainers,
				UserGroupID: this.SelectedUserGroup.UserGroupID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadContainerList();
				this.AddedContainer.emit(Date.now()); //Update Schools list
			}
		});
	}

	onRemove() {
		this.errorMessage = "";

		// if(this.SelectedUsers.length == 0){
		//   this.errorMessage = "Select users to remove";
		//   return;
		// }

		var lstSchoolGroupID: number[] = [];

		for (var i = 0; i < this.SelectedContainers.length; i++) {
			var next = Number(this.SelectedContainers[i].SchoolGroupID);
			lstSchoolGroupID = [...lstSchoolGroupID, next];
		}

		//Create Query Data
		let data: ContainersToChangeModel = {
			UserGroupID: this.SelectedUserGroup.UserGroupID,
			SchoolGroupIDs: lstSchoolGroupID,
		};

		//Call SP
		var result = this.sysAdminService.UserGroupRemoveContainers(data);
		result.subscribe(
			(response) => {
				this.loadContainerList();
				this.AddedContainer.emit(Date.now()); //Update Schools list
			},
			(error) => {}
		);
	}
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Events
	/////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	/////////////////////////////////////////
}
